module.exports = __webpack_public_path__ + "static/media/right.abb58694.svg";